import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6dda5d16"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  style: {
    "height": "100%"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination",
  slot: "pagination"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", {
    class: "swiper",
    style: _normalizeStyle({
      'margin-top': $props.content.topMargin + 'px',
      'margin-left': $props.content.leftMargin + 'px',
      'margin-right': $props.content.rightMargin + 'px',
      'margin-bottom': $props.content.bottomMargin + 'px'
    })
  }, [_createVNode(_component_swiper, {
    class: "w_0",
    ref: "goodSwiper",
    options: $data.swiperOption
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.content.imgs, (item, index) => {
      return _withDirectives((_openBlock(), _createBlock(_component_swiper_slide, {
        key: 'grap' + index,
        class: "w_0"
      }, {
        default: _withCtx(() => [item.type == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("a", {
          href: item.href
        }, [_createElementVNode("img", {
          style: {
            "width": "100%",
            "height": "100%",
            "-webkit-touch-callout": "none",
            "pointer-events": "none"
          },
          src: item.img,
          fit: "cover"
        }, null, 8, _hoisted_3)], 8, _hoisted_2)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
          style: {
            "width": "100%",
            "height": "100%",
            "object-fit": "cover",
            "-webkit-touch-callout": "none",
            "pointer-events": "none"
          },
          src: item.img,
          fit: "cover"
        }, null, 8, _hoisted_5)]))]),
        _: 2
      }, 1024)), [[_vShow, item.img != '']]);
    }), 128))]),
    _: 1
  }, 8, ["options"]), _hoisted_6], 4);
}